(function() {
  if (window.eGainOneTagUtil) {
    return;
  }
  var dom,
    doc,
    where,
    iframe = document.createElement('iframe');
  iframe.src = 'javascript:false';
  iframe.title = '';
  (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0';
  where = document.getElementsByTagName('script');
  where = where[where.length - 1];
  where.parentNode.insertBefore(iframe, where);
  try {
    doc = iframe.contentWindow.document;
  } catch (e) {
    dom = document.domain;
    iframe.src = "javascript:var d=document.open();d.domain='" + dom + "';void(0);";
    doc = iframe.contentWindow.document;
  }
  doc.open()._l = function() {
    var js = this.createElement('script');
    if (dom) this.domain = dom;
    js.id = 'egain-docked-chat-async';
    var src = getEgainChatUrl();
    if (src !== '') {
      var dockedChatJSPath = src.substring(0, src.lastIndexOf('/') + 1);
      dockedChatJSPath += 'egain-docked-chat.js';
      js.src = dockedChatJSPath;
      this.body.appendChild(js);
    }
  };
  doc.write('<body onload="document._l();">');
  doc.close();
  function getEgainChatUrl() {
    var src = '';
    var addOn = document.getElementById('_egainallowdockchat');
    if (addOn && addOn.src) {
      src = addOn.src;
    }
    if (src === '') {
      var scripts = document.getElementsByTagName('SCRIPT');
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src.replace(/\\/, '/').indexOf('/egain-chat.') != -1) {
          src = scripts[i].src;
        }
      }
    }
    return src;
  }
})();
